<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M19 14.61a1 1 0 00-1 1V18H6v-2.46l.54.55a1 1 0 00.71.3A1 1 0 008 14.68l-2.29-2.26a1 1 0 00-1.41 0L2 14.68a1 1 0 001.42 1.41l.58-.55V19a1 1 0 001 1h14a1 1 0 001-1v-3.39a1 1 0 00-1-1zM22 7.91a1 1 0 00-1.42 0l-.58.55V5a1 1 0 00-1-1H5a1 1 0 00-1 1v3.39a1 1 0 002 0V6h12v2.46l-.54-.55A1 1 0 0016 9.32l2.26 2.26a1 1 0 00.7.29 1 1 0 00.71-.29L22 9.32a1 1 0 000-1.41z"/></svg>